import DataTable from "@/components/core/data-table";
import { Form } from "@/components/core/forms/form.tsx";
import { useModal } from "@/components/core/modals/use-modal";
import Pagination from "@/components/core/pagination";
import { ScrollArea } from "@/components/core/scroller";
import { caseActivityLogsQueryOptions } from "@/features/case-record/api/queries/case-activity-log-query";
import { IconLock, IconLockOpen2 } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import clsx from "clsx";
import { formatDate } from "date-fns/format";
import { useForm } from "react-hook-form";

export default function CaseActivityLogModal({ caseId }: { caseId: string }) {
	const modal = useModal();

	const navigate = useNavigate();
	const query = useQuery(
		caseActivityLogsQueryOptions({
			case_record_id: caseId,
			status: "",
		}),
	);
	const logs = query.data?.data;
	const meta = query.data?.meta;

	const form = useForm({
		defaultValues: {},
	});

	const columns: ColumnDef<CaseRecord>[] = [
		{
			id: "activity",
			label: "Activity",
			cellClassName: "min-w-[40%] max-w-[40%] w-[40%]",
			cell: ({ data, onClick }) => (
				<span>
					{data.causer?.full_name} {data.description} {data.module}{" "}
				</span>
			),
		},
		{
			id: "old_properties",
			label: "Old Value",
			cellClassName: "min-w-[300px] max-w-[300px] w-[300px]",
			cell: ({ data }) => {
				const oldValues = data.properties?.old;
				if (!oldValues || Object.keys(oldValues).length === 0) {
					return <span className="text-xs text-foreground/40">No old values</span>;
				}

				return (
					<div className="flex flex-col gap-1">
						{Object.entries(oldValues)
							.filter(([key, value]) => value !== null)
							.map(([key, value], index) => (
								<div key={index} className="flex gap-1 text-xs">
									<span className="font-medium text-foreground/70">{key}:</span>
									<span className="text-foreground/60 truncate max-w-[100px]">{typeof value === "object" ? JSON.stringify(value) : String(value)}</span>
								</div>
							))}
					</div>
				);
			},
		},
		{
			id: "new_properties",
			label: "New Value",
			cellClassName: "min-w-[300px] max-w-[300px] w-[300px]",
			cell: ({ data }) => {
				const newValues = data.properties?.attributes;
				if (!newValues || Object.keys(newValues).length === 0) {
					return <span className="text-xs text-foreground/40">No new values</span>;
				}

				return (
					<div className="flex flex-col gap-1">
						{Object.entries(newValues)
							.filter(([key, value]) => value !== null)
							.map(([key, value], index) => (
								<div key={index} className="flex gap-1 text-xs">
									<span className="font-medium text-foreground/70">{key}:</span>
									<span className="text-foreground/60 truncate max-w-[100px]">{typeof value === "object" ? JSON.stringify(value) : String(value)}</span>
								</div>
							))}
					</div>
				);
			},
		},
		{
			id: "ip_address",
			label: "IP Address",
			cellClassName: "min-w-[120px] max-w-[120px] w-[120px]",
			cell: ({ data }) => <span>{data.ip_address}</span>,
		},
		{
			id: "created_at",
			label: "Date",
			cellClassName: "min-w-[120px] max-w-[120px] w-[120px]",
			cell: ({ data }) => formatDate(data.created_at, "PPp"),
		},
	];

	return (
		<Form {...form}>
			<form className="w-full max-h-[540px]">
				<ScrollArea className="flex grow h-[calc(100svh -220px)]">
					<div className="flex flex-col w-full rounded-md border border-border/50 max-h-[540px] scroll">
						<DataTable
							className="border-collapse"
							data={logs}
							columns={columns}
							stickyHead={false}
							stickyCol={false}
							showBorder={true}
							compact={true}
							showToolbar={false}
						/>
						{/* <table>
							<thead>
								<tr className="border-b-2 border-border/50">
									<th className=" text-left text-foreground-dark p-3">Activity</th>
									<th className=" text-left text-foreground-dark p-3">Old Value</th>
									<th className=" text-left text-foreground-dark p-3">New Value</th>
									<th className=" text-right text-foreground-dark p-3">Date</th>
								</tr>
							</thead>
							<tbody>
								{logs?.map((log, index) => (
									<tr key={index} className="border-b border-border/50 last:border-b-0">
										<td width={"40%"} className="px-3 py-2">
											{" "}
											{log.causer?.full_name} {log.description} {log.module}{" "}
										</td>
										<td className="px-3 py-2">{log.old_properties}</td>
										<td className="px-3 py-2">{log.new_properties}</td>
										<td width={"190px"} className="px-3">
											{" "}
											{formatDate(log.created_at, "PPp")}
										</td>
									</tr>
								))}
							</tbody>
						</table> */}
					</div>
				</ScrollArea>
			</form>
		</Form>
	);
}
